const LogoForNavigationIcon = ({
  width,
  height,
}: {
  width?: number
  height?: number
}) => {
  return (
    <svg
      width={width || "158"}
      height={height || "203"}
      viewBox="0 0 158 203"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M95.5577 0.195312C75.9491 0.195312 58.4445 27.4841 47.0037 70.1637C35.5482 27.4841 18.0436 0.195312 -1.56501 0.195312C-36.0409 0.195312 -64 91.0002 -64 203.002H-36.2381C-36.2381 98.9923 -20.7134 14.6772 -1.56501 14.6772C17.5834 14.6772 33.1227 92.51 33.1227 188.52H60.8846C60.8846 92.51 76.4166 14.6772 95.5723 14.6772C114.728 14.6772 130.238 98.9923 130.238 203.002H158C157.993 91.0002 130.034 0.195312 95.5577 0.195312Z"
        fill="#FFBC0D"
      />
    </svg>
  )
}

export default LogoForNavigationIcon
